import { useEffect, useRef, useState } from "react";

export const useDuplicationCheck = <T>(value: T, checkfn: (oldval: T, newval?: T) => boolean) => {
	const olddata = useRef<T>();

	const [data, setData] = useState<T>();

	useEffect(() => {
		if (checkfn(value, olddata.current)) return;
		olddata.current = value;
		setData(value);
	}, [value]);

	return data;
};
